import React, { useEffect, useState, useContext } from "react";
import { AuthContext } from "../../contexts/AuthContext";
import UsageServices from "../../services/usageServices";
import useUsage from "../../hooks/useUsage";
import marginTopAllComponent from "../../utils/styleGlobal";
import io from "socket.io-client";
import { nbrPage, paginate, renderPagination } from "../../utils/pagination";
import UserService from "../../services/userServices";
import Loader from "../../components/loader/loader";
import "../../assets/style/usageListePage.css";

const socket = io(process.env.REACT_APP_SOCKET || "http://localhost:4000");

const UsageListPage = ({ setAlert }) => {
  const { isLogged } = useContext(AuthContext);
  const [usages, setUsages] = useState([]);
  const [filteredUsages, setFilteredUsages] = useState([]);
  const [periodFilter, setPeriodFilter] = useState("all");
  const [userFilter, setUserFilter] = useState("");
  const [currentPage, setCurrentPage] = useState(1);
  const usagesPerPage = nbrPage;
  const [users, setUsers] = useState([]);
  const [isLoading, setIsLoading] = useState(true);
  const [isLoadingUser, setIsLoadingUser] = useState(true);
  const [dateFrom, setDateFrom] = useState("");
  const [dateTo, setDateTo] = useState("");
  const [showDateFilters, setShowDateFilters] = useState(false);
  const [specificDate, setSpecificDate] = useState("");
  const [showModalUpdate, setShowModalUpdate] = useState(false);
  const [selectedUsage, setSelectedUsage] = useState(null);

  const { updateUsageComputer } = useUsage();


  const filterData = (usages, periodType, userFilter, users) => {
    const now = new Date();
    return usages.filter((usage) => {
      const usageDate = new Date(usage.createdAt);
      const matchesDateRange = specificDate
        ? usageDate.toDateString() === new Date(specificDate).toDateString()
        : (!dateFrom || usageDate >= new Date(dateFrom)) &&
        (!dateTo || usageDate <= new Date(dateTo));


      const matchesPeriod =
        (periodType === "all" ||
          (periodType === "today" && usageDate.toDateString() === now.toDateString()) ||
          (periodType === "weekly" &&
            usageDate.getDate() >= now.getDate() - now.getDay() &&
            usageDate.getDate() <= now.getDate() - now.getDay() + 6) ||
          (periodType === "monthly" &&
            usageDate.getMonth() === now.getMonth() &&
            usageDate.getFullYear() === now.getFullYear())) &&
        matchesDateRange;


      const matchedUser = users.find((u) => u._id === usage.idUser);
      const fullName = matchedUser ? `${matchedUser.nom && matchedUser.nom} ${matchedUser.prenom && matchedUser.prenom}`.toLowerCase() : "";
      const matchesUser =
        usage?.computerName?.toLowerCase().includes(userFilter?.toLowerCase()) ||
        fullName.includes(userFilter?.toLowerCase());

      return matchesPeriod && matchesUser;
    });
  };

  useEffect(() => {
    setIsLoadingUser(true);
    UserService.getAll()
      .then((res) => {
        setUsers(res.data.data);
        setIsLoadingUser(false);
      })
      .catch((err) => {
        console.error("Erreur:", err);
        setIsLoadingUser(false);
      });
  }, [isLogged]);

  useEffect(() => {
    const fetchUsages = async () => {
      setIsLoading(true);
      try {
        const res = await UsageServices.getAll();
        const allUsages = res?.data?.data ? res?.data?.data : [];
        setUsages(allUsages);
        setFilteredUsages(filterData(allUsages, periodFilter, userFilter, users, specificDate));
        setIsLoading(false);
      } catch (err) {
        console.error("Erreur lors de la récupération des usages :", err);
        setAlert({ type: "danger", message: "Erreur lors du chargement des usages." });
        setIsLoading(false);
      }
    };

    fetchUsages();

    return () => {
      socket.off("usageUpdated");
    };
  }, [isLogged]);

  useEffect(() => {
    const filtered = filterData(usages, periodFilter, userFilter, users, specificDate);
    setFilteredUsages(filtered);
    setCurrentPage(1);
  }, [usages, periodFilter, userFilter, users, dateFrom, dateTo, specificDate]);


  useEffect(() => {
    if (specificDate) {
      setDateFrom("");
      setDateTo("");
    }
  }, [specificDate]);

  useEffect(() => {
    if (dateFrom || dateTo) {
      setSpecificDate("");
    }
  }, [dateFrom, dateTo]);

  const formatDataUsed = (totalMo) => {
    if (totalMo >= 1024 * 1024) {
      return `${(totalMo / (1024 * 1024)).toFixed(2)} To`;
    } else if (totalMo >= 1024) {
      return `${(totalMo / 1024).toFixed(2)} Go`;
    } else {
      return `${totalMo.toFixed(2)} Mo`;
    }
  };

  const totalDataUsed = filteredUsages.reduce((sum, usage) => sum + parseFloat(usage.dataUsed || 0), 0);

  const { currentData, totalPages } = paginate(filteredUsages, currentPage, usagesPerPage);
  const handlePageChange = (page) => {
    if (page > 0 && page <= totalPages) {
      setCurrentPage(page);
    }
  };

  function formatDataUsage(mo) {
    if (!mo && mo !== 0) return "N/A";
    if (mo >= 1024) {
      return (mo / 1024).toFixed(2) + " Go";
    }
    return (mo).toFixed(2) + " Mo";
  }

  const updateData = async (id, data) => {
    await updateUsageComputer(id, data).then((res) => {
      setUsages((prevUsages) =>
        prevUsages.map((usage) => (usage._id === id ? res.data.data : usage))
      );
    }).catch((err) => console.log(err));
  }

  return (
    <div
      className="container-fluid"
      style={{
        marginTop: marginTopAllComponent(),
        maxWidth: "100vw",
        overflowX: "hidden",
        padding: "0 10px",
      }}
    >
      <h2 className="mb-4 text-center">Liste consommation</h2>

      {isLogged ? (
        isLoading || isLoadingUser ? (
          <Loader />
        ) : (
          <div>
            <div
              className="table-container"
              style={{
                width: "100%",
                overflowX: "auto",
                padding: "10px",
                backgroundColor: "#f8f9fa",
                borderRadius: "10px",
              }}
            >
              <div className="filters mb-4">
                <div className="row g-2">
                  <div className="col-12 col-md-6">
                    <select
                      value={periodFilter}
                      onChange={(e) => setPeriodFilter(e.target.value)}
                      className="form-control"
                    >
                      <option value="all">Tout afficher</option>
                      <option value="today">Aujourd'hui</option>
                      <option value="weekly">Cette semaine</option>
                      <option value="monthly">Ce mois-ci</option>
                    </select>
                  </div>
                  <div className="col-12 col-md-6">
                    <input
                      type="text"
                      className="form-control"
                      placeholder="Filtrer par utilisateur ou ordinateur"
                      value={userFilter}
                      onChange={(e) => setUserFilter(e.target.value)}
                    />
                  </div>
                  <div className="text-end mb-3">
                    <button
                      className="btn btn-outline-secondary"
                      onClick={() => setShowDateFilters(!showDateFilters)}
                    >
                      {showDateFilters ? "Masquer le filtre par date" : "Afficher le filtre par date"}
                    </button>
                  </div>

                  <div className={`row g-2 mb-3 date-filter-wrapper ${showDateFilters ? "show" : "hide"}`}>
                    <div className="col-sm-12 col-md-4">
                      <div className="d-flex align-items-center flex-wrap gap-2">
                        <label htmlFor="specificDate" className="fw-bold">Date unique:</label>
                        <input
                          type="date"
                          id="specificDate"
                          className="form-control w-100"
                          value={specificDate}
                          onChange={(e) => setSpecificDate(e.target.value)}
                        />
                      </div>
                    </div>

                    <div className="col-sm-12 col-md-4">
                      <div className="d-flex align-items-center flex-wrap gap-2">
                        <label htmlFor="dateFrom" className="fw-bold">Date Début :</label>
                        <input
                          type="date"
                          id="dateFrom"
                          className="form-control w-100"
                          value={dateFrom}
                          onChange={(e) => setDateFrom(e.target.value)}
                        />
                      </div>
                    </div>

                    <div className="col-sm-12 col-md-4">
                      <div className="d-flex align-items-center flex-wrap gap-2">
                        <label htmlFor="dateTo" className="fw-bold">Date Fin :</label>
                        <input
                          type="date"
                          id="dateTo"
                          className="form-control w-100"
                          value={dateTo}
                          onChange={(e) => setDateTo(e.target.value)}
                        />
                      </div>
                    </div>
                  </div>


                </div>
              </div>
              {/* Tableau */}
              <div
                className="table-responsive"
                style={{
                  overflowX: "auto",
                  backgroundColor: "#f8f9fa",
                  borderRadius: "10px",
                  padding: "10px",
                  boxShadow: "0px 4px 10px rgba(0, 0, 0, 0.1)",
                }}
              >
                <table
                  className="table table-bordered table-hover"
                  style={{
                    minWidth: "800px",
                    backgroundColor: "#ffffff",
                    overflow: "hidden",
                  }}
                >
                  <thead className="table-primary">
                    <tr style={{ backgroundColor: "#007bff", color: "white", textAlign: "center" }}>
                      <th>Utilisateur</th>
                      <th>Ordinateur</th>
                      <th>Connexion type</th>
                      <th>Consommation</th>
                      <th>Adresse IP</th>
                      <th>Adresse Mac</th>
                      <th>Date d'insertion</th>
                      <th>Action</th>
                    </tr>
                  </thead>
                  <tbody>
                    {currentData.length > 0 ? (
                      currentData.map((usage) => {
                        const matchedUser = users.find((u) => u._id === usage.idUser);

                        return (
                          <tr
                            key={usage._id}
                            style={{
                              transition: "background-color 0.3s",
                              cursor: "pointer",
                            }}
                            onMouseEnter={(e) => (e.currentTarget.style.backgroundColor = "#f1f1f1")}
                            onMouseLeave={(e) => (e.currentTarget.style.backgroundColor = "white")}
                          >
                            <td style={{ textAlign: "center", fontWeight: "bold" }}>
                              {matchedUser ? `${matchedUser.nom} ${matchedUser.prenom}` : "Inconnu"}
                            </td>
                            <td style={{ textAlign: "center", fontWeight: "bold" }}>{usage.computerName}</td>
                            <td style={{ textAlign: "center" }}>{usage.connectionType}</td>
                            <td style={{ textAlign: "center", color: "#28a745", fontWeight: "bold" }}>
                              {formatDataUsage(usage.dataUsed)}
                            </td>
                            <td>{usage.ipAddress}</td>
                            <td>{usage.addressMac}</td>
                            <td style={{ textAlign: "center", fontStyle: "italic" }}>
                              {new Date(usage.createdAt).toLocaleString()}
                            </td>
                            <td style={{ textAlign: "center" }}>
                              <button className="btn btn-sm btn-outline-primary" onClick={() => {
                                setSelectedUsage(usage);
                                setShowModalUpdate(true);
                              }}>
                                Modifier
                              </button>
                            </td>
                          </tr>
                        );
                      })
                    ) : (
                      <tr>
                        <td colSpan="6" className="text-center text-warning" style={{ fontSize: "16px", padding: "10px" }}>
                          Aucune consommation trouvée pour cette période ou utilisateur.
                        </td>
                      </tr>
                    )}
                  </tbody>
                </table>

                {renderPagination(totalPages, currentPage, handlePageChange)}
                <div className="mb-3 text-end">
                  <span
                    style={{
                      backgroundColor: "#e9ecef",
                      padding: "10px 20px",
                      borderRadius: "10px",
                      fontWeight: "bold",
                      fontSize: "16px",
                      color: "#333",
                      boxShadow: "0 2px 6px rgba(0,0,0,0.1)",
                    }}
                  >
                    Total consommation : {formatDataUsed(totalDataUsed)}
                  </span>
                </div>

                {showModalUpdate && selectedUsage && (
                  <div className="modal show d-block" tabIndex="-1">
                    <div className="modal-dialog">
                      <div className="modal-content">
                        <div className="modal-header">
                          <h5 className="modal-title">Modifier la consommation</h5>
                          <button
                            type="button"
                            className="btn-close"
                            onClick={() => setShowModalUpdate(false)}
                          ></button>
                        </div>
                        <div className="modal-body">
                          <div className="mb-3">
                            <label htmlFor="dataUsed" className="form-label">Consommation (Mo) :</label>
                            <input
                              type="number"
                              id="dataUsed"
                              className="form-control"
                              value={selectedUsage.dataUsed || 0}
                              onChange={(e) =>
                                setSelectedUsage({ ...selectedUsage, dataUsed: e.target.value })
                              }
                            />
                          </div>
                        </div>
                        <div className="modal-footer">
                          <button
                            type="button"
                            className="btn btn-secondary"
                            onClick={() => setShowModalUpdate(false)}
                          >
                            Annuler
                          </button>
                          <button
                            type="button"
                            className="btn btn-primary"
                            onClick={() => {
                              updateData(selectedUsage._id, { dataUsed: selectedUsage.dataUsed });
                              setShowModalUpdate(false);
                            }}
                          >
                            Enregistrer
                          </button>
                        </div>
                      </div>
                    </div>
                  </div>
                )}
              </div>
            </div>
          </div>
        )
      ) : (
        <p className="text-danger text-center mt-4">
          Vous devez être connecté pour voir la liste des utilisateurs.
        </p>
      )}
    </div >
  );
};

export default UsageListPage;